module.exports = __webpack_public_path__ + "img/193.dc91d860.jpg";